/* eslint-disable @typescript-eslint/no-explicit-any */
import { showAlertDialog } from '@juvare/common-web-ui/DialogHelper';
import { getErrorMessage } from '@juvare/widget-ui/Utils';
import React from 'react';
export function buildHiddenTab(props, params) {
    var _a, _b;
    const parentConfig = (_a = props.parentProps) === null || _a === void 0 ? void 0 : _a.config;
    const siblingCheckboxComponents = [];
    const siblingYesNoComponents = [];
    const siblingNumberComponents = [];
    const siblingTextComponents = [];
    const siblingRadioComponents = [];
    const siblingRadioConfigs = {};
    const siblingSelectComponents = [];
    const siblingSelectConfigs = {};
    const selectComponentValues = [];
    const siblingYesNoConfigs = {};
    if (parentConfig) {
        const parentWidget = props.widgets.find((w) => w.type === parentConfig.type);
        if (parentWidget && parentWidget.childConfigs) {
            parentWidget.childConfigs(parentConfig).forEach((siblingConfig) => {
                if (siblingConfig !== props.config && siblingConfig.key) {
                    const component = '^' + siblingConfig.key;
                    switch (siblingConfig.type) {
                        case 'form.checkbox':
                            siblingCheckboxComponents.push(component);
                            selectComponentValues.push({ value: component, label: 'Checkbox: ' + siblingConfig.label });
                            break;
                        case 'form.number':
                            siblingNumberComponents.push(component);
                            selectComponentValues.push({ value: component, label: 'Number: ' + siblingConfig.label });
                            break;
                        case 'form.text':
                            siblingTextComponents.push(component);
                            selectComponentValues.push({ value: component, label: 'Text: ' + siblingConfig.label });
                            break;
                        case 'form.radio':
                            siblingRadioComponents.push(component);
                            siblingRadioConfigs[component] = siblingConfig;
                            selectComponentValues.push({ value: component, label: 'Radio: ' + siblingConfig.label });
                            break;
                        case 'form.select':
                            siblingSelectComponents.push(component);
                            siblingSelectConfigs[component] = siblingConfig;
                            selectComponentValues.push({ value: component, label: 'Select: ' + siblingConfig.label });
                            break;
                        case 'form.yesNo':
                            siblingYesNoComponents.push(component);
                            siblingYesNoConfigs[component] = siblingConfig;
                            selectComponentValues.push({ value: component, label: 'Select: ' + siblingConfig.label });
                            break;
                    }
                }
            });
        }
        selectComponentValues.push({ value: '$', label: 'Other' });
    }
    const children = [
        {
            type: 'form.panel',
            key: 'hiddenConfig',
            children: [
                {
                    type: 'form.radio',
                    key: 'type',
                    values: [
                        { value: 'visible', label: 'Always Visible' },
                        { value: 'hide', label: 'Hide When' },
                        { value: 'show', label: 'Show When' },
                        { value: 'custom', label: 'Custom' },
                    ],
                    style: {
                        inline: true,
                    },
                },
                {
                    type: 'form.panel',
                    hidden: {
                        custom: (handler) => {
                            var _a;
                            const when = (_a = handler.up().down('type')) === null || _a === void 0 ? void 0 : _a.getData();
                            return when !== 'hide' && when !== 'show';
                        },
                    },
                    children: [
                        {
                            type: 'form.select',
                            key: 'component',
                            label: 'When Component',
                            values: selectComponentValues,
                            hidden: {
                                when: '^type',
                                dataEq: 'visible',
                            },
                        },
                        {
                            type: 'form.radio',
                            key: 'dataEqCheckbox',
                            label: 'Checkbox Is',
                            values: [
                                { value: true, label: 'Checked' },
                                { value: false, label: 'Not Checked' },
                            ],
                            validate: {
                                required: true,
                            },
                            hidden: {
                                custom: (handler) => { var _a; return !siblingCheckboxComponents.includes((_a = handler.up().down('component')) === null || _a === void 0 ? void 0 : _a.getData()); },
                            },
                        },
                        {
                            type: 'form.number',
                            key: 'dataEqNumber',
                            label: 'Number Equals',
                            validate: {
                                required: true,
                            },
                            hidden: {
                                custom: (handler) => { var _a; return !siblingNumberComponents.includes((_a = handler.up().down('component')) === null || _a === void 0 ? void 0 : _a.getData()); },
                            },
                        },
                        {
                            type: 'form.yesNo',
                            key: 'dataEqYesNo',
                            label: 'Yes/No Is',
                            validate: {
                                required: true,
                            },
                            hidden: {
                                custom: (handler) => { var _a; return !siblingYesNoComponents.includes((_a = handler.up().down('component')) === null || _a === void 0 ? void 0 : _a.getData()); },
                            },
                        },
                        {
                            type: 'form.text',
                            key: 'dataEqText',
                            label: 'Text Equals',
                            multiline: true,
                            rows: 2,
                            validate: {
                                required: true,
                            },
                            hidden: {
                                custom: (handler) => { var _a; return !siblingTextComponents.includes((_a = handler.up().down('component')) === null || _a === void 0 ? void 0 : _a.getData()); },
                            },
                        },
                        {
                            type: 'form.checkboxList',
                            key: 'dataInCheckboxList',
                            label: 'Value Is One Of',
                            allowInvalidValues: true,
                            validate: {
                                required: true,
                            },
                            hidden: {
                                custom: (handler) => { var _a; return !siblingRadioComponents.includes((_a = handler.up().down('component')) === null || _a === void 0 ? void 0 : _a.getData()); },
                            },
                            event: {
                                onUpdateAny: (handler) => {
                                    var _a;
                                    return onUpdateAnyValuesBasedOnSiblingConfig(handler, siblingRadioConfigs[(_a = handler.up().down('component')) === null || _a === void 0 ? void 0 : _a.getData()]);
                                },
                            },
                        },
                        {
                            type: 'form.multiSelect',
                            key: 'dataInMultiSelect',
                            label: 'Value Is One Of',
                            allowInvalidValues: true,
                            validate: {
                                required: true,
                            },
                            hidden: {
                                custom: (handler) => { var _a; return !siblingSelectComponents.includes((_a = handler.up().down('component')) === null || _a === void 0 ? void 0 : _a.getData()); },
                            },
                            event: {
                                onUpdateAny: (handler) => {
                                    var _a;
                                    return onUpdateAnyValuesBasedOnSiblingConfig(handler, siblingSelectConfigs[(_a = handler.up().down('component')) === null || _a === void 0 ? void 0 : _a.getData()]);
                                },
                            },
                        },
                        {
                            type: 'form.panel',
                            hidden: {
                                custom: (handler) => { var _a; return ((_a = handler.up().down('component')) === null || _a === void 0 ? void 0 : _a.getData()) !== '$'; },
                            },
                            children: [
                                {
                                    type: 'form.text',
                                    key: 'when',
                                    label: 'Component Query',
                                    validate: {
                                        required: true,
                                    },
                                },
                                {
                                    type: 'form.radio',
                                    key: 'whenDataEqType',
                                    label: 'Value Equals',
                                    values: [
                                        { value: 'text', label: 'Specific Text' },
                                        { value: 'number', label: 'Specific Number' },
                                        { value: 'true', label: 'True' },
                                        { value: 'false', label: 'False' },
                                        { value: 'eqJson', label: 'JSON Value' },
                                        { value: 'inJson', label: 'One Of JSON Values' },
                                    ],
                                    style: {
                                        inline: true,
                                    },
                                },
                                {
                                    type: 'form.number',
                                    key: 'whenDataEqNumber',
                                    label: 'Number',
                                    validate: {
                                        required: true,
                                    },
                                    hidden: {
                                        custom: (handler) => { var _a; return ((_a = handler.up().down('whenDataEqType')) === null || _a === void 0 ? void 0 : _a.getData()) !== 'number'; },
                                    },
                                },
                                {
                                    type: 'form.text',
                                    key: 'whenDataEqText',
                                    label: 'Text',
                                    multiline: true,
                                    rows: 2,
                                    validate: {
                                        required: true,
                                    },
                                    hidden: {
                                        custom: (handler) => { var _a; return ((_a = handler.up().down('whenDataEqType')) === null || _a === void 0 ? void 0 : _a.getData()) !== 'text'; },
                                    },
                                },
                                {
                                    type: 'form.text',
                                    key: 'whenDataEqJson',
                                    label: 'JSON',
                                    multiline: true,
                                    rows: 2,
                                    validate: {
                                        required: true,
                                        custom: (value) => {
                                            if (value) {
                                                try {
                                                    JSON.parse(value);
                                                }
                                                catch (e) {
                                                    return e.toString();
                                                }
                                            }
                                            return undefined;
                                        },
                                    },
                                    hidden: {
                                        custom: (handler) => { var _a; return ((_a = handler.up().down('whenDataEqType')) === null || _a === void 0 ? void 0 : _a.getData()) !== 'eqJson'; },
                                    },
                                },
                                {
                                    type: 'form.text',
                                    key: 'whenDataInJson',
                                    label: 'JSON Array',
                                    multiline: true,
                                    rows: 6,
                                    validate: {
                                        required: true,
                                        custom: (value) => {
                                            if (value) {
                                                try {
                                                    if (Array.isArray(JSON.parse(value))) {
                                                        return undefined;
                                                    }
                                                    else {
                                                        return 'JSON array expected';
                                                    }
                                                }
                                                catch (e) {
                                                    return e.toString();
                                                }
                                            }
                                            return undefined;
                                        },
                                    },
                                    hidden: {
                                        custom: (handler) => { var _a; return ((_a = handler.up().down('whenDataEqType')) === null || _a === void 0 ? void 0 : _a.getData()) !== 'inJson'; },
                                    },
                                },
                            ],
                        },
                    ],
                },
                {
                    type: 'form.panel',
                    hidden: {
                        custom: (handler) => {
                            var _a;
                            const when = (_a = handler.up().down('type')) === null || _a === void 0 ? void 0 : _a.getData();
                            return when !== 'custom';
                        },
                    },
                    children: [
                        {
                            type: 'form.text',
                            key: 'custom',
                            label: 'Custom JavaScript Function',
                            emptyAsNull: true,
                            multiline: true,
                            rows: 6,
                            style: {
                                monospace: true,
                            },
                            validate: {
                                required: true,
                                custom: (value) => {
                                    if (value) {
                                        try {
                                            Function('"use strict"; return (function(handler) { ' + value + '; })')();
                                        }
                                        catch (error) {
                                            return getErrorMessage(error);
                                        }
                                    }
                                    return undefined;
                                },
                            },
                        },
                        {
                            type: 'form.button',
                            label: 'Show Example',
                            event: {
                                onClick: () => {
                                    showAlertDialog({
                                        title: 'Custom Visibility Function Example',
                                        content: React.createElement("pre", { style: { margin: 0 } }, exampleHiddenCustomJavaScript),
                                    });
                                },
                            },
                            style: {
                                align: 'right',
                            },
                        },
                    ],
                },
            ],
        },
        {
            type: 'form.checkbox',
            key: 'clearDataOnHide',
            label: 'Clear Data On Hide',
            description: 'When component state changed from visible to hidden data will be cleared',
            hidden: {
                when: '^hiddenConfig/type',
                dataEq: 'visible',
            },
        },
        ...((_b = params === null || params === void 0 ? void 0 : params.children) !== null && _b !== void 0 ? _b : []),
    ];
    const onLoad = (data) => {
        data.hiddenConfig = { type: 'visible' };
        if (typeof data.hidden === 'object') {
            let dataEq;
            let dataIn;
            if (typeof data.hidden.custom === 'string') {
                data.hiddenConfig.type = 'custom';
                data.hiddenConfig.custom = data.hidden.custom;
            }
            else if (data.hidden.dataEq != null) {
                data.hiddenConfig.type = 'hide';
                dataEq = data.hidden.dataEq;
            }
            else if (data.hidden.dataIn != null) {
                data.hiddenConfig.type = 'hide';
                dataIn = data.hidden.dataIn;
            }
            else if (data.hidden.dataNotEq != null) {
                data.hiddenConfig.type = 'show';
                dataEq = data.hidden.dataNotEq;
            }
            else if (data.hidden.dataNotIn != null) {
                data.hiddenConfig.type = 'show';
                dataIn = data.hidden.dataNotIn;
            }
            if (dataEq != null && data.hidden.when) {
                if (typeof dataEq === 'boolean' && siblingCheckboxComponents.includes(data.hidden.when)) {
                    data.hiddenConfig.component = data.hidden.when;
                    data.hiddenConfig.dataEqCheckbox = dataEq;
                }
                else if (typeof dataEq === 'number' && siblingNumberComponents.includes(data.hidden.when)) {
                    data.hiddenConfig.component = data.hidden.when;
                    data.hiddenConfig.dataEqNumber = dataEq;
                }
                else if (typeof dataEq === 'boolean' && siblingYesNoComponents.includes(data.hidden.when)) {
                    data.hiddenConfig.component = data.hidden.when;
                    data.hiddenConfig.dataEqYesNo = dataEq;
                }
                else if (typeof dataEq === 'string' && siblingTextComponents.includes(data.hidden.when)) {
                    data.hiddenConfig.component = data.hidden.when;
                    data.hiddenConfig.dataEqText = dataEq;
                }
                else if (siblingRadioComponents.includes(data.hidden.when)) {
                    data.hiddenConfig.component = data.hidden.when;
                    data.hiddenConfig.dataInCheckboxList = [dataEq];
                }
                else if (siblingSelectComponents.includes(data.hidden.when)) {
                    data.hiddenConfig.component = data.hidden.when;
                    data.hiddenConfig.dataInMultiSelect = [dataEq];
                }
                else {
                    data.hiddenConfig.component = '$';
                    data.hiddenConfig.when = data.hidden.when;
                    switch (typeof dataEq) {
                        case 'boolean':
                            data.hiddenConfig.whenDataEqType = dataEq ? 'true' : 'false';
                            break;
                        case 'number':
                            data.hiddenConfig.whenDataEqType = 'number';
                            data.hiddenConfig.whenDataEqNumber = dataEq;
                            break;
                        case 'string':
                            data.hiddenConfig.whenDataEqType = 'text';
                            data.hiddenConfig.whenDataEqText = dataEq;
                            break;
                        default:
                            data.hiddenConfig.whenDataEqType = 'eqJson';
                            data.hiddenConfig.whenDataEqJson = JSON.stringify(dataEq, undefined, '  ');
                    }
                }
            }
            if (dataIn != null && data.hidden.when) {
                if (siblingRadioComponents.includes(data.hidden.when)) {
                    data.hiddenConfig.component = data.hidden.when;
                    data.hiddenConfig.dataInCheckboxList = dataIn;
                }
                else if (siblingSelectComponents.includes(data.hidden.when)) {
                    data.hiddenConfig.component = data.hidden.when;
                    data.hiddenConfig.dataInMultiSelect = dataIn;
                }
                else {
                    data.hiddenConfig.component = '$';
                    data.hiddenConfig.when = data.hidden.when;
                    data.hiddenConfig.whenDataEqType = 'inJson';
                    data.hiddenConfig.whenDataInJson = JSON.stringify(dataIn, undefined, '  ');
                }
            }
        }
        if (params === null || params === void 0 ? void 0 : params.onLoad) {
            data = params.onLoad(data);
        }
        return data;
    };
    const onSubmit = (data) => {
        var _a, _b, _c, _d, _e, _f, _g, _h;
        if (((_a = data.hiddenConfig) === null || _a === void 0 ? void 0 : _a.type) === 'hide' || ((_b = data.hiddenConfig) === null || _b === void 0 ? void 0 : _b.type) === 'show') {
            let when;
            let dataEq;
            let dataIn;
            if (data.hiddenConfig.component && data.hiddenConfig.component !== '$') {
                if (siblingCheckboxComponents.includes(data.hiddenConfig.component)) {
                    when = data.hiddenConfig.component;
                    dataEq = data.hiddenConfig.dataEqCheckbox;
                }
                else if (siblingNumberComponents.includes(data.hiddenConfig.component)) {
                    when = data.hiddenConfig.component;
                    dataEq = data.hiddenConfig.dataEqNumber;
                }
                else if (siblingYesNoComponents.includes(data.hiddenConfig.component)) {
                    when = data.hiddenConfig.component;
                    dataEq = data.hiddenConfig.dataEqYesNo;
                }
                else if (siblingTextComponents.includes(data.hiddenConfig.component)) {
                    when = data.hiddenConfig.component;
                    dataEq = data.hiddenConfig.dataEqText;
                }
                else if (siblingRadioComponents.includes(data.hiddenConfig.component)) {
                    when = data.hiddenConfig.component;
                    dataIn = data.hiddenConfig.dataInCheckboxList;
                }
                else if (siblingSelectComponents.includes(data.hiddenConfig.component)) {
                    when = data.hiddenConfig.component;
                    dataIn = data.hiddenConfig.dataInMultiSelect;
                }
            }
            else if (data.hiddenConfig.component === '$' && data.hiddenConfig.when) {
                when = data.hiddenConfig.when;
                switch (data.hiddenConfig.whenDataEqType) {
                    case 'text':
                        dataEq = data.hiddenConfig.whenDataEqText;
                        break;
                    case 'number':
                        dataEq = data.hiddenConfig.whenDataEqNumber;
                        break;
                    case 'true':
                        dataEq = true;
                        break;
                    case 'false':
                        dataEq = false;
                        break;
                    case 'eqJson':
                        dataEq = JSON.parse((_c = data.hiddenConfig.whenDataEqJson) !== null && _c !== void 0 ? _c : 'null');
                        break;
                    case 'inJson':
                        dataIn = JSON.parse((_d = data.hiddenConfig.whenDataInJson) !== null && _d !== void 0 ? _d : '[]');
                        break;
                }
            }
            if (when && (dataEq != null || dataIn)) {
                data.hidden = {
                    when: when,
                };
                if (dataIn && dataIn.length === 1) {
                    dataEq = dataIn[0];
                }
                if (dataEq != null) {
                    if (((_e = data.hiddenConfig) === null || _e === void 0 ? void 0 : _e.type) === 'hide') {
                        data.hidden.dataEq = dataEq;
                    }
                    else {
                        data.hidden.dataNotEq = dataEq;
                    }
                }
                else {
                    if (((_f = data.hiddenConfig) === null || _f === void 0 ? void 0 : _f.type) === 'hide') {
                        data.hidden.dataIn = dataIn;
                    }
                    else {
                        data.hidden.dataNotIn = dataIn;
                    }
                }
            }
        }
        else if (((_g = data.hiddenConfig) === null || _g === void 0 ? void 0 : _g.type) === 'custom') {
            data.hidden = {
                custom: (_h = data.hiddenConfig) === null || _h === void 0 ? void 0 : _h.custom,
            };
        }
        else {
            delete data.hidden;
            delete data.clearDataOnHide;
        }
        delete data.hiddenConfig;
        if (params === null || params === void 0 ? void 0 : params.onSubmit) {
            data = params.onSubmit(data);
        }
        return data;
    };
    return { label: 'Conditional', children, onLoad, onSubmit };
}
function onUpdateAnyValuesBasedOnSiblingConfig(handler, siblingConfig) {
    let reloadValues = false;
    if (siblingConfig && (siblingConfig.values || siblingConfig.valueProvider)) {
        if (siblingConfig.values) {
            if (handler.config.values !== siblingConfig.values) {
                handler.config.values = siblingConfig.values;
                delete handler.config.valueProvider;
                reloadValues = true;
            }
        }
        else if (handler.config.valueProvider !== siblingConfig.valueProvider) {
            delete handler.config.values;
            handler.config.valueProvider = siblingConfig.valueProvider;
            reloadValues = true;
        }
    }
    else if (handler.config.valueProvider) {
        delete handler.config.valueProvider;
        reloadValues = true;
    }
    if (reloadValues) {
        handler.reloadValues();
    }
}
const exampleHiddenCustomJavaScript = `// This code changes visibility based on combined value of two other components
const value1 = handler.up().down('component1')?.getData();
const value2 = handler.up().down('component2')?.getData();
return value1 === 'a' && value2 === 'b';
`;
